// extracted by mini-css-extract-plugin
export default {"base":"ViewerLayout_base__F5soE","baseLoader":"ViewerLayout_baseLoader__ubU5x"};